import { saveEditedSystemMeshBot } from './saveEditedSystemMeshBot';
import EzloActions from '../EzloActions';
import { createRule } from './createRule';

/**
 * Returns the appropriate thunk function for saving a MeshBot based on its type and edit state.
 *
 * This factory function determines which save operation to use:
 * - For system MeshBots: converts to custom MeshBot (creates new + disables original)
 * - For existing custom MeshBots: updates the existing MeshBot
 * - For new custom MeshBots: creates a new MeshBot
 *
 * @param {string|null} meshBotId - ID of existing MeshBot, or null for new MeshBot
 * @param {boolean} isSystemRole - Whether the MeshBot has system role (non-editable)
 * @returns {Function} Thunk function that accepts (serial, rule, meshBotId) parameters
 *
 * @example
 * // Save new custom MeshBot
 * const saveThunk = getSaveMeshBotThunk(null, false);
 * dispatch(saveThunk(serial, ruleData)); // calls createRule
 *
 * @example
 * // Edit existing custom MeshBot
 * const saveThunk = getSaveMeshBotThunk('existing-id', false);
 * dispatch(saveThunk(serial, ruleData, 'existing-id')); // calls EzloActions.editRule
 *
 * @example
 * // Convert system MeshBot to custom
 * const saveThunk = getSaveMeshBotThunk('system-id', true);
 * dispatch(saveThunk(serial, ruleData, 'system-id')); // calls saveEditedSystemMeshBot
 *
 * @example
 * // Real-world usage pattern
 * dispatch(getSaveMeshBotThunk(meshBotId, isSystemRole)(serial, updatedMeshBotPayload, meshBotId))
 *   .then(() => {
 *     console.log('MeshBot saved successfully');
 *   })
 *   .catch((error) => {
 *     console.error('Failed to save MeshBot:', error);
 *   });
 */
export const getSaveMeshBotThunk = (meshBotId, isSystemRole) => {
    if (isSystemRole) {
        return saveEditedSystemMeshBot;
    }

    return meshBotId ? EzloActions.editRule : createRule;
};
